import { useState } from "react"

import OnboardingTile from "./onboarding_tile"
import Header from "./header"
import DownloadModal from "./download_modal"

import android from "images/icons/android.svg"
import apple from "images/icons/apple.svg"
import neither from "images/icons/neither.svg"

import "./index.scss"
import { submitPreferredPlatforms } from "./api"

interface Props {
  onPlatformSelected: () => void
  images: { android: string; apple: string }
  onClickBack: () => void
}

const PlatformSelection = ({ onPlatformSelected, images, onClickBack }: Props) => {
  const platforms = [
    {
      name: "Android",
      icon: android,
      color: "#073042",
      backgroundStyle: `center / cover url(${images.android})`,
    },
    {
      name: "iPhone",
      icon: apple,
      backgroundStyle: `center / cover url(${images.apple})`,
    },
    {
      name: "Neither",
      icon: neither,
      backgroundStyle: "linear-gradient(126.88deg, #A9A8A8 11.43%, #707070 98.14%)",
    },
  ]

  const [showDownload, setShowDownload] = useState(false)
  const [downloadPlatform, setDownloadPlatform] = useState("")
  const [selectedPlatforms, setSelectedPlatforms] = useState(new Set<string>())

  const onSelect = (platformName: string): void => {
    const platforms = new Set(selectedPlatforms)

    if (platforms.has(platformName)) {
      platforms.delete(platformName)
    } else if (platformName === "Neither") {
      platforms.clear()
      platforms.add(platformName)
    } else if (["Android", "iPhone"].includes(platformName) && platforms.has("Neither")) {
      platforms.delete("Neither")
      platforms.add(platformName)
    } else {
      platforms.add(platformName)
    }

    setSelectedPlatforms(platforms)
  }

  const onContinue = async (): Promise<void> => {
    await submitPreferredPlatforms(Array.from(selectedPlatforms as Set<string>).map((p: string) => p.toLowerCase()))
    onPlatformSelected()
  }

  const showAppDownload = (platform: string) => {
    setDownloadPlatform(platform)
    setShowDownload(true)
  }

  return (
    <div styleName="platform-selection-view">
      <Header title="Let's start!" onClickBack={onClickBack} />
      <div styleName="container platform-selection">
        <div>
          <p className="txt-body-3">
            What mobile device(s) do you currently use?
            <br />
            This is important and helps us find the best Applets for you.
          </p>
          <ul styleName="service-list">
            {platforms.map(p => (
              <li key={p.name}>
                <OnboardingTile
                  onClick={() => onSelect(p.name)}
                  onboardingItem={p}
                  selected={selectedPlatforms.has(p.name)}
                  isPlatformSelect
                />
                {p.name !== "Neither" && selectedPlatforms.has(p.name) && (
                  <a
                    className="link-standalone"
                    styleName="download-link"
                    role="button"
                    onClick={() => showAppDownload(p.name)}
                  >
                    Download App
                  </a>
                )}
              </li>
            ))}
          </ul>
        </div>
      </div>
      {selectedPlatforms.size > 0 && (
        <div styleName="platform-selection-continue">
          <button onClick={onContinue} className="button-primary">
            Continue
          </button>
        </div>
      )}
      {
        <DownloadModal
          downloadPlatform={downloadPlatform}
          showDownload={showDownload}
          setShowDownload={setShowDownload}
        />
      }
    </div>
  )
}

export default PlatformSelection
